import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFacilityDailyReport } from "../services/api";

const initialState = {
  reportData: null,
  status: "idle",
  error: null,
  loading: false,
  lastFetched: null
};

export const fetchFacilityDailyReport = createAsyncThunk(
  "facilityDailyReport/fetchFacilityDailyReport",
  async ({ facilityId, date }) => {
    try {
      const response = await getFacilityDailyReport(facilityId, date);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const facilityDailyReportSlice = createSlice({
  name: "facilityDailyReport",
  initialState,
  reducers: {
    clearReportData: (state) => {
      state.reportData = null;
      state.status = "idle";
      state.error = null;
      state.lastFetched = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacilityDailyReport.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFacilityDailyReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.reportData = action.payload.data;
        state.lastFetched = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchFacilityDailyReport.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.error.message;
        state.reportData = null;
      });
  },
});

export const { clearReportData, setLoading } = facilityDailyReportSlice.actions;

// Selectors
export const selectFacilityDailyReport = (state) => state.facilityDailyReport.reportData;
export const selectFacilityDailyReportStatus = (state) => state.facilityDailyReport.status;
export const selectFacilityDailyReportError = (state) => state.facilityDailyReport.error;
export const selectFacilityDailyReportLoading = (state) => state.facilityDailyReport.loading;

export default facilityDailyReportSlice.reducer; 